<template>
	<div class="flex gap-8 flex-row flex-wrap view-image">
		<template v-for="({ url, fileName }, key) in viewFileList">
			<div
				v-if="
					['png', 'jpg', 'jpeg', 'bmp', 'gif'].indexOf(
						url.substring(url.lastIndexOf('.') + 1)
					) !== -1
				"
				:key="key + '0'"
			>
				<div v-if="edit" class="relative img-preview w-60 h-60">
					<el-image :src="url" :fit="'contain'" class="w-60 h-60" />
					<span
						class="handle"
						:style="{
							height: height,
							width: width
						}"
					>
						<span>
							<em class="iconfont mr-12 cursor-pointer" @click="preview(url)"
								>&#xe611;</em
							>
							<em class="iconfont cursor-pointer" @click="$emit('delete', url)"
								>&#xe616;</em
							>
						</span>
					</span>
				</div>
				<div v-else>
					<el-image
						:src="url"
						:fit="'contain'"
						:preview-src-list="[url]"
						:style="{
							height: height,
							width: width
						}"
					/>
				</div>
			</div>
			<div v-else :key="key">
				<div class="el-icon-tickets"></div>
				<a
					href="javascript:;"
					@click="
						openDownload({
							fileName,
							url
						})
					"
					:title="fileName"
					>{{ fileName }}</a
				>
			</div>
		</template>
		<el-image-viewer
			v-if="showViewer"
			:on-close="closeViewer"
			:url-list="previewList"
		/>
	</div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
	name: 'viewImage',
	components: {
		ElImageViewer
	},
	model: {
		prop: 'fileList'
	},
	props: {
		fileList: [Array, String],
		edit: Boolean,
		height: {
			type: Number,
			default: 148
		},
		width: {
			type: Number,
			default: 148
		}
	},
	data() {
		return {
			previewList: [],
			showViewer: false
		}
	},
	computed: {
		viewFileList() {
			if (this.fileList && Array.isArray(this.fileList)) {
				return this.fileList
					.map(it => {
						if (it && typeof it === 'object') {
							return {
								url: it.url || it.fileUrl,
								fileName: it.name || it.fileName
							}
						} else {
							return {
								url: it,
								fileName: ''
							}
						}
					})
					.filter(it => it.url)
			} else if (this.fileList && !Array.isArray(this.fileList)) {
				return [
					{
						url: this.fileList
					}
				]
			}
			return []
		}
	},
	methods: {
		closeViewer() {
			this.showViewer = false
		},
		preview(url) {
			this.previewList = [url]
			this.showViewer = true
		},
		openDownload({ url, fileName }) {
			const config = {
				name: fileName,
				url: url
			}
			this.$global.download_path(config)
		}
	}
}
</script>

<style lang="scss">
.view-image {
	.el-image {
		img {
			width: 60px;
			height: 60px;
			border-radius: 4px;
		}
	}
}
</style>
